export const API_BASE_URL = process.env.REACT_APP_API_NODE_BASE_URL;
export const BASE_URL = process.env.REACT_APP_NODE_BASE_URL;
export const LANGUAGES = [
    "English",
    // "Yoruba",
    "Swahili",
    // "Nigerian Pidgin"
];